// Module
var code = `<span class="cp-badge cp-badge--{{ vm.tone }}" ng-transclude></span> `;
// Exports
module.exports = code;